import { noop } from 'lodash';
import { useCallback, useEffect } from 'react';

import { useFade } from '@providers/ui/FadeProvider';
import { useAuthContext } from '@services/Auth';
import { ClientType } from '@services/Auth/types';
import { FadeAnimationPageKey } from '@src/types/providers';

const useBundleBotPostAnimation = (
  pageKey: FadeAnimationPageKey,
  isBundleBotDisplayed?: boolean
) => {
  const { animationsCompleted, setAnimationCompleted } = useFade();
  const { activeClient } = useAuthContext();

  const hasSeenPage = animationsCompleted[pageKey];
  const skipAnimation =
    process.env.E2E_TESTS === 'true' ||
    process.env.NODE_ENV === 'development' ||
    activeClient === ClientType.OktaInternal;

  const handleAnimationComplete = useCallback(() => {
    if (!hasSeenPage && !skipAnimation) {
      setAnimationCompleted(pageKey);
    }
  }, [hasSeenPage, skipAnimation, pageKey, setAnimationCompleted]);

  useEffect(() => {
    if (isBundleBotDisplayed === false && !hasSeenPage && !skipAnimation) {
      handleAnimationComplete();
    }
  }, [
    handleAnimationComplete,
    hasSeenPage,
    isBundleBotDisplayed,
    skipAnimation,
  ]);

  if (pageKey === 'default') {
    return {
      componentFade: true,
      handleAnimationComplete: noop,
    };
  }

  return {
    componentFade: hasSeenPage || skipAnimation,
    handleAnimationComplete,
  };
};

export { useBundleBotPostAnimation };
